import ServicePageHero from "../components/ServicePageHero";
import { openConsultationMail } from "../config/contact";
import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FiArrowUpRight, FiPlus, FiChevronDown, FiChevronUp, FiZap, FiBarChart2, FiTarget, FiTrendingUp } from "react-icons/fi";
import { Helmet } from "react-helmet-async";
import ServiceDetailSection from "../components/ServiceDetailSection";
import ServiceIntroSection from "../components/ServiceIntroSection";
import img_customer_relationship_management_amico from "../assets/Customer relationship management-amico.png";
import img_feedback_pana_1 from "../assets/Feedback-pana (1).png";
import img_mobile_marketing_amico from "../assets/Mobile Marketing-amico.png";
import img_mobile_marketing_pana from "../assets/Mobile Marketing-pana.png";
import img_mobile_marketing_rafiki from "../assets/Mobile Marketing-rafiki.png";
import img_subscriptions_amico from "../assets/Subscriptions-amico.png";
import img_about_img1 from "../assets/Choose-bro.png";
import img_about_img2 from "../assets/Starting a business project-amico.png";

const FAQ_DATA = [
  {
    question: "1. What is email marketing?",
    answer: "Email marketing involves sending targeted emails to your audience to promote your business, products, or services."
  },
  {
    question: "2. How effective is email marketing?",
    answer: "Email marketing is highly effective for nurturing leads and driving conversions when done with the right strategy."
  },
  {
    question: "3. What type of emails do you create?",
    answer: "We create promotional emails, newsletters, and automated campaigns based on your business needs."
  },
  {
    question: "4. How do you measure email performance?",
    answer: "We track metrics like open rates, click rates, and conversions to evaluate campaign performance."
  }
];

const scrollReveal = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.2 },
  transition: { duration: 0.6, ease: "easeOut" },
};


const staggerContainer = {
  initial: {},
  whileInView: {
    transition: {
      staggerChildren: 0.1,
    },
  },
};

const itemFade = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.5, ease: "easeOut" },
};


const WHY_ICONS = [
  <FiTarget />,
  <FiBarChart2 />,
  <FiZap />,
  <FiTrendingUp />,
];
const EmailMarketingPage = () => {
  const [openFaq, setOpenFaq] = useState(null);
  const [activeWhy, setActiveWhy] = useState(0);

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const scrollToContact = openConsultationMail; // replaced

  return (
    <>
      <Helmet>
        <title>Email Marketing Services in Delhi NCR | Email Experts</title>
        <meta name="description" content="Boost conversions with email marketing services in Delhi NCR. Hire experts for bulk email campaigns and customer engagement." />
      </Helmet>
      <main className="email-marketing-page">
      <ServicePageHero
        badge="Our Services"
        title="Best Email Marketing Services"
        subtitle="Connect with your audience and drive conversions through targeted email campaigns."
        breadcrumb="Home > Services > Email Marketing"
        image={img_mobile_marketing_amico}
      />


      <ServiceIntroSection
        heading="How Email Marketing Helps Your Business Grow"
        paragraph1="Email marketing helps you connect directly with your audience, nurture leads, and build long-term relationships."
        paragraph2="As a results-driven email marketing agency, we focus on creating targeted campaigns that engage users, improve conversions, and support your business growth."
        imageLeft={img_mobile_marketing_pana}
        imageRight={img_subscriptions_amico}
      />

      <ServiceDetailSection isReversed={false} label="Our Email Marketing Strategy" title="Audience Segmentation & Planning"
        description="We segment your audience based on behavior, interests, and preferences to create targeted campaigns. This ensures your emails reach the right people."
        longDescription="Targeted communication improves engagement and increases the chances of conversions."
        image={img_mobile_marketing_rafiki}
      />
      <ServiceDetailSection isReversed={true} bgLight title="Email Campaign Creation"
        description="We design and write engaging email campaigns that capture attention and encourage action. Our focus is on creating relevant and valuable content."
        longDescription="Well-crafted emails help improve open rates and user engagement."
        image={img_customer_relationship_management_amico}
      />
      <ServiceDetailSection isReversed={false} title="Automation & Workflow Setup"
        description="We set up automated email workflows to nurture leads and maintain consistent communication. This helps save time and improve efficiency."
        longDescription="Automation ensures your audience receives timely and relevant messages."
        image={img_feedback_pana_1}
      />
      <ServiceDetailSection isReversed={true} bgLight title="Performance Tracking & Optimization"
        description="We monitor metrics like open rates, clicks, and conversions to evaluate performance. This helps us understand what works best."
        longDescription="Based on insights, we optimize campaigns for better results."
        image={img_feedback_pana_1}
      />

      {/* WHY CHOOSE US - DARK VERSION */}
      <section className="dark-why-section">
        <div className="container-custom">
          <motion.div className="dark-why-header" {...scrollReveal}>
            <span className="dark-why-badge">Why Choose Us</span>
            <h2>Why Businesses Trust Our Email Marketing Expertise</h2>
          </motion.div>

          <motion.div 
            className="dark-why-grid"
            variants={staggerContainer}
            initial="initial"
            whileInView="whileInView"
            viewport={{ once: true, amount: 0.1 }}
          >
            <motion.div className="dark-why-list" variants={itemFade}>
              {[
                { 
                  title: "1. Targeted Campaign Strategies", 
                  desc: "We create campaigns tailored to your audience and business goals. This ensures better engagement and results. A focused approach helps improve campaign performance." 
                },
                { 
                  title: "2. Focus on Engagement & Conversions", 
                  desc: "Our strategies are designed to improve user engagement and drive conversions. We focus on delivering real results. This helps your business generate better outcomes from email marketing." 
                },
                { 
                  title: "3. Data-Driven Approach", 
                  desc: "We use data and insights to improve campaign performance. This helps in making better decisions. Continuous analysis ensures better results over time." 
                },
                { 
                  title: "4. Consistent Communication", 
                  desc: "We help maintain regular communication with your audience. This keeps your brand active and relevant. Consistency helps build trust and long-term relationships." 
                }
              ].map((item, idx) => (
                <div 
                  key={idx} 
                  className={`dark-why-item ${activeWhy === idx ? 'active' : ''}`}
                  onMouseEnter={() => setActiveWhy(idx)}
                >
                  <div className="dark-why-item-header">
                    <span className="dark-why-item-icon-left">{WHY_ICONS[idx]}</span>
                    <h4>{item.title}</h4>
                    <span className="dark-why-item-icon">
                      {activeWhy === idx ? <FiArrowUpRight /> : <FiPlus />}
                    </span>
                  </div>
                  <div className="dark-why-item-content">
                    <p>{item.desc}</p>
                  </div>
                </div>
              ))}
            </motion.div>

            <motion.div className="dark-why-visual" variants={itemFade}>
              <img src={img_about_img1} alt="Expertise 1" className="dark-oval-1" />
              <img src={img_about_img2} alt="Expertise 2" className="dark-oval-2" />
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* FAQ SECTION */}
      <section className="faq-section py-20">
        <div className="container-custom max-w-4xl">
          <motion.h2 className="section-title text-center mb-16" {...scrollReveal}>Frequently Asked Questions</motion.h2>
          <div className="faq-list">
            {FAQ_DATA.map((faq, index) => (
              <motion.div 
                key={index} 
                className={`faq-item ${openFaq === index ? 'active' : ''}`}
                {...scrollReveal}
                transition={{ delay: index * 0.1 }}
              >
                <button className="faq-question" onClick={() => toggleFaq(index)}>
                  <span>{faq.question}</span>
                  {openFaq === index ? <FiChevronUp /> : <FiChevronDown />}
                </button>
                <AnimatePresence>
                  {openFaq === index && (
                    <motion.div 
                      className="faq-answer"
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3 }}
                    >
                      <p>{faq.answer}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA SECTION */}
      <section className="service-page-cta service-page-cta--soft py-20">
        <div className="container-custom">
          <motion.div 
            className="service-page-cta-inner text-center"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h2>Turn Emails Into Real Business Results</h2>
            <p className="mb-8">Our email marketing services in Delhi NCR are designed to engage your audience, nurture leads, and drive conversions.</p>
            <button className="nav-btn mx-auto" onClick={scrollToContact} style={{ padding: '14px 32px', fontSize: '16px' }}>
              Get Free Consultation
              <span className="nav-btn-arrow" style={{ width: '28px', height: '28px' }}>
                <FiArrowUpRight />
              </span>
            </button>
          </motion.div>
        </div>
      </section>
      </main>
    </>
  );
};

export default EmailMarketingPage;
